(function () {
  if (window.__organoFsbInit) return;
  window.__organoFsbInit = true;

  var KEY = 'organo_ship_zone';
  // Records whether the stored zone came from the shopper tapping a button or was merely
  // the fallback. Without it, a guest's stale 'west' would outrank the East Malaysia
  // address of the account they later signed into (fixed 2026-09-17).
  var SRC = 'organo_ship_zone_src';
  var ZONES = ['west', 'east', 'sg'];

  function safeLs(fn, dflt) {
    // Private windows and blocked site data make localStorage throw, not return null.
    try { return fn(); } catch (e) { return dflt; }
  }

  function validZone(z) { return ZONES.indexOf(z) !== -1; }

  function zoneFor(root) {
    var stored = safeLs(function () { return localStorage.getItem(KEY); }, null);
    var isUserPick = safeLs(function () { return localStorage.getItem(SRC); }, null) === 'user';
    var fromAccount = root.getAttribute('data-customer-zone') || '';
    if (isUserPick && validZone(stored)) return stored;   // an explicit tap always wins
    if (validZone(fromAccount)) return fromAccount;       // signed-in default address
    if (validZone(stored)) return stored;                 // guest's earlier tap
    return 'west';
  }

  var COPY = {
    en: {
      away: function (amt, zone) { return 'You are <strong>' + amt + '</strong> away from free shipping to ' + zone + '.'; },
      done: function (zone) { return 'Your order ships <strong>free</strong> to ' + zone + '.'; },
      flat: function (rate, need, zone) { return 'Shipping to ' + zone + ' is ' + rate + '. Free from ' + need + '.'; },
      zones: { west: 'West Malaysia', east: 'East Malaysia', sg: 'Singapore' }
    },
    ms: {
      away: function (amt, zone) { return 'Tinggal <strong>' + amt + '</strong> lagi untuk penghantaran percuma ke ' + zone + '.'; },
      done: function (zone) { return 'Pesanan anda dihantar <strong>percuma</strong> ke ' + zone + '.'; },
      flat: function (rate, need, zone) { return 'Penghantaran ke ' + zone + ' ialah ' + rate + '. Percuma dari ' + need + '.'; },
      zones: { west: 'Semenanjung Malaysia', east: 'Sabah &amp; Sarawak', sg: 'Singapura' }
    },
    zh: {
      away: function (amt, zone) { return '再加 <strong>' + amt + '</strong> 即可享' + zone + '免运费。'; },
      done: function (zone) { return '你的订单已符合' + zone + '<strong>免运费</strong>。'; },
      flat: function (rate, need, zone) { return zone + '运费为 ' + rate + '，满 ' + need + ' 免运费。'; },
      zones: { west: '西马', east: '东马', sg: '新加坡' }
    }
  };

  function pack(root) {
    var loc = (root.getAttribute('data-locale') || 'en').toLowerCase();
    if (loc.indexOf('ms') === 0) return COPY.ms;
    if (loc.indexOf('zh') === 0) return COPY.zh;
    return COPY.en;
  }

  function money(cents) {
    return 'RM' + (cents / 100).toFixed(2);
  }

  function render(root, totalCents) {
    var zone = zoneFor(root);

    var threshold = parseInt(root.getAttribute('data-' + zone), 10);
    var rate = parseInt(root.getAttribute('data-' + zone + '-rate'), 10);
    var c = pack(root);
    var zoneName = c.zones[zone];

    root.querySelectorAll('.organo-fsb__zone').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-zone') === zone));
    });

    var msg = root.querySelector('[data-organo-fsb-msg]');
    var fill = root.querySelector('[data-organo-fsb-fill]');
    var track = root.querySelector('[data-organo-fsb-track]');
    var pct = Math.max(0, Math.min(100, (totalCents / threshold) * 100));

    if (totalCents <= 0) {
      msg.innerHTML = c.flat(money(rate), money(threshold), zoneName);
      root.classList.remove('is-complete');
    } else if (totalCents >= threshold) {
      msg.innerHTML = c.done(zoneName);
      root.classList.add('is-complete');
    } else {
      msg.innerHTML = c.away(money(threshold - totalCents), zoneName);
      root.classList.remove('is-complete');
    }

    fill.style.width = pct + '%';
    track.setAttribute('aria-valuenow', Math.round(pct));
  }

  var lastTotal = null;

  function renderAll(totalCents) {
    if (typeof totalCents === 'number') lastTotal = totalCents;
    document.querySelectorAll('[data-organo-freeship-bar]').forEach(function (root) {
      var t = (lastTotal === null) ? parseInt(root.getAttribute('data-total'), 10) : lastTotal;
      render(root, isNaN(t) ? 0 : t);
    });
  }

  var pending = null;
  function refresh() {
    // Cart mutations are AJAX in this theme, so Liquid's cart.total_price goes stale.
    // Re-read the source of truth rather than trusting the rendered markup.
    // Use the UNWRAPPED fetch. Routing this read through the wrapper below made every
    // refresh schedule another refresh: one /cart.js request every ~150 ms for the whole
    // visit, 123 of them in a single Lighthouse trace (found 2026-09-06).
    clearTimeout(pending);
    pending = setTimeout(function () {
      (origFetch || window.fetch).call(window, '/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderAll(cart.total_price); })
        .catch(function () { /* leave the last good value on screen */ });
    }, 120);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.organo-fsb__zone') : null;
    if (!btn) return;
    e.preventDefault();
    safeLs(function () {
      localStorage.setItem(KEY, btn.getAttribute('data-zone'));
      localStorage.setItem(SRC, 'user');
    });
    renderAll();
  });

  // No single cart event is reliable across this theme's drawer and cart page, so watch
  // the network instead. Match "/cart" and "sections=" rather than "/cart/": the drawer is
  // injected by a section-render request, which does NOT contain the trailing slash. Testing
  // for "/cart/" alone left the drawer's copy of the bar rendered but blank.
  function isCartUrl(href) {
    // Plain reads of the cart (/cart.js, /cart.json) never change it; only mutations and
    // section re-renders do. Ignoring reads is what keeps refresh() from re-triggering itself.
    if (href.indexOf('/cart.js') !== -1 || href.indexOf('/cart.json') !== -1) return false;
    return href.indexOf('/cart') !== -1 || href.indexOf('sections=') !== -1 || href.indexOf('section_id=') !== -1;
  }
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function () {
      var url = arguments[0];
      var href = (typeof url === 'string') ? url : (url && url.url) || '';
      var p = origFetch.apply(this, arguments);
      if (isCartUrl(href)) p.then(refresh, function () {});
      return p;
    };
  }
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartUrl(String(url))) this.addEventListener('load', refresh);
    return origOpen.apply(this, arguments);
  };

  // Backstop for the drawer. Opening it injects a second copy of this bar into the DOM, and
  // neither the observer nor the network hook is guaranteed to catch every theme's injection
  // path. Two cheap re-renders after any click cover it without polling.
  document.addEventListener('click', function () {
    setTimeout(renderAll, 400);
    setTimeout(renderAll, 1200);
  }, true);

  ['DOMContentLoaded', 'shopify:section:load'].forEach(function (evt) {
    document.addEventListener(evt, function () { renderAll(); });
  });
  if (document.readyState !== 'loading') renderAll();

  // The drawer is injected after load, so catch bars that appear later.
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      for (var j = 0; j < records[i].addedNodes.length; j++) {
        var n = records[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches && n.matches('[data-organo-freeship-bar]') || n.querySelector && n.querySelector('[data-organo-freeship-bar]'))) {
          renderAll();
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
